import { AxiosInstance } from 'axios';
import { ApiService } from '../model/Api.model';
import { generateQueryString } from 'src/util/helper';
import { IFeeAdditive } from '../interface/Fee/IFeeAdditive';

enum FeeAdditiveServiceEnum {
  feePayment = "/fee-payment",
  reprocess = "/reprocess"
}

export class FeeAdditiveService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, '/fee/additive');
  }

  public getByFeePayment = async (id: number): Promise<IFeeAdditive[]> => await this.GET(`${FeeAdditiveServiceEnum.feePayment}?${generateQueryString({ id })}`);
  public reprocess = async (id: number): Promise<void> => await this.POST(`${FeeAdditiveServiceEnum.reprocess}/${id}`);
}
